/**
 * Продуктовая аналитика для РФ-рынка: Яндекс.Метрика.
 * Активна только если задан REACT_APP_YM_ID (иначе полный no-op).
 * Загружается после согласия на cookie (см. CookieConsent).
 */

const YM_ID = process.env.REACT_APP_YM_ID;
let initialized = false;

export function initAnalytics() {
  if (initialized || !YM_ID || typeof window === 'undefined') return;
  initialized = true;

  /* eslint-disable */
  (function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    for (var j = 0; j < document.scripts.length; j++) {
      if (document.scripts[j].src === r) return;
    }
    (k = e.createElement(t)),
      (a = e.getElementsByTagName(t)[0]),
      (k.async = 1),
      (k.src = r),
      a.parentNode.insertBefore(k, a);
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');
  /* eslint-enable */

  window.ym(Number(YM_ID), 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: false,
  });
}

/** Событие продуктовой воронки (register, onboarding_complete, first_check, purchase, ...). */
export function trackEvent(name, params = {}) {
  if (!YM_ID || typeof window === 'undefined' || !window.ym) return;
  try {
    window.ym(Number(YM_ID), 'reachGoal', name, params);
  } catch (_) {}
}
